<ng-container *ngIf="profile$ | async; let profile">
  <div
    class="dashboard-response"
    *ngIf="responseBanner$ | async; let responseBanner"
  >
    <app-response-banner
      [success]="responseBanner.success"
      [invisible]="!responseBanner.open"
      [successMessage]="responseBanner.successMessage"
      [errorMessage]="responseBanner.errorMessage"
    ></app-response-banner>
  </div>
  <div class="tab-navigation">
    <app-tab-button
      [active]="router.url.includes('myprofile')"
      [title]="'dashboard_tabs.profile' | translate"
      routerLink="profile"
    ></app-tab-button>
    <app-tab-button
      [active]="router.url.includes('company')"
      [title]="'dashboard_tabs.company' | translate"
      routerLink="company"
      *ngIf="profile.completed"
    ></app-tab-button>
    <app-tab-button
      [active]="router.url.includes('members')"
      [title]="'dashboard_tabs.members' | translate"
      routerLink="members"
      *ngIf="profile.role === UserRole.ADMIN && (company$ | async)?.completed"
    ></app-tab-button>
    <app-tab-button
      [active]="router.url.includes('impersonation')"
      [title]="'dashboard_tabs.impersonation' | translate"
      routerLink="impersonation"
      *ngIf="mayStartImpersonation(profile) || profile.impersonatedBy"
    ></app-tab-button>
    <app-button
      class="logout-button"
      testId="profile-logout-button"
      [small]="true"
      (click)="logoutProfile()"
      [title]="'dashboard_tabs.logout' | translate"
    ></app-button>
  </div>
  <div class="tab-container">
    <router-outlet></router-outlet>
  </div>
</ng-container>
